import React, { createContext, useContext, useState, useEffect } from 'react';
import { usePlayerContext } from '../Context';
import { CurrentTimeEvents } from '../../sdk/PlayerEvents';
import { Events, State } from '../../types/player';
import Utils from '../../utils/Utils';

const LiveDVRIndicator = () => {
  const { sdk } = usePlayerContext();

  if(!sdk.isDvr())
    return null;

  if(!sdk.options().getDvrSettings().showControl)
    return null;

  const [currentTime, setCurrentTime] = useState(
    sdk.getCurrentTime() as number,
  );
  const [duration, setCurrentDuration] = useState(sdk.getDuration() as number);
  const [isDVRisLive, setIsDVRisLive] = useState(sdk.isDvrIsLive() as boolean);

  useEffect(() => {
    sdk.on(Events.CURRENT_TIME, (data: CurrentTimeEvents) => {
      setIsDVRisLive(sdk.isDvrIsLive());
    });
  }, []);

  function onBackToLive() {
    sdk.seek(sdk.getDuration() as number);
  }

  return (
    <div
      onClick={ onBackToLive }
      className={`${sdk.getClassNamePrefix()}-player-control ${sdk.getClassNamePrefix()}-player-control-live-dvr-indicator`}
    >
      { isDVRisLive ? '🔴' : '⚪' } Live { isDVRisLive }
    </div>
  );
};

export default LiveDVRIndicator;
